import { render, staticRenderFns } from "./job-record-list.vue?vue&type=template&id=260f9b21&scoped=true&"
import script from "./job-record-list.vue?vue&type=script&lang=ts&"
export * from "./job-record-list.vue?vue&type=script&lang=ts&"
import style0 from "./job-record-list.vue?vue&type=style&index=0&id=260f9b21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f9b21",
  null
  
)

export default component.exports